<template>
  <b-card>
    <form method="post" action="" autocomplete="off">
      <div slot="header">
        <strong>{{title}}</strong>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <strong>{{$t('BASICDATA')}}</strong>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <b-form-fieldset v-bind:label="$t('USERNAME')">
            <inputvalidation :formerror="formError" name="username"><b-form-input type="text" v-model="formData.username" v-bind:placeholder="$t('USERNAME')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-4">
          <b-form-fieldset v-bind:label="$t('PASSWORD')">
            <inputvalidation :formerror="formError" name="password"><b-form-input type="password" v-model="formData.password" v-bind:placeholder="$t('PASSWORD')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-4">
          <b-form-fieldset v-bind:label="$t('USEREMAIL')">
            <inputvalidation :formerror="formError" name="userEmail"><b-form-input type="email" v-model="formData.userEmail" v-bind:placeholder="$t('USEREMAIL')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6" v-if="globals.groupId == 1">
          <b-form-fieldset v-bind:label="$t('USERGROUP')">
            <inputvalidation :formerror="formError" name="groupId"><b-form-select :options="aclGroups.root" v-model="formData.groupId" value-field="groupId" text-field="groupName"></b-form-select></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-6" v-if="globals.groupId == 3">
          <b-form-fieldset v-bind:label="$t('USERGROUP')">
            <inputvalidation :formerror="formError" name="groupId">
              <b-form-select :options="[{groupId: 3, groupName: 'Master user'}, {groupId: 4, groupName: 'User'}]" v-model="formData.groupId" value-field="groupId" text-field="groupName"></b-form-select>
            </inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-6">
          <b-form-fieldset v-bind:label="$t('STATUS')">
            <inputvalidation :formerror="formError" name="status"><b-form-select :options="status" v-model="formData.status"></b-form-select></inputvalidation>
          </b-form-fieldset>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12" v-if="globals.groupId == 1">
          <b-form-fieldset v-bind:label="$t('COMPANY')">
            <inputvalidation :formerror="formError" name="companyId">
              <b-form-select :options="companydata.root" v-model="formData.companyId" value-field="companyId" text-field="companyName"></b-form-select>
            </inputvalidation>
          </b-form-fieldset>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <strong>{{$t('ADDITIONALDATA')}}</strong>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <b-form-fieldset v-bind:label="$t('NAME')">
            <inputvalidation :formerror="formError" name="name"><b-form-input type="text" v-model="formData.name" v-bind:placeholder="$t('NAME')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-4">
          <b-form-fieldset v-bind:label="$t('SURNAME')">
            <inputvalidation :formerror="formError" name="surname"><b-form-input type="text" v-model="formData.surname" v-bind:placeholder="$t('SURNAME')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-4">
          <b-form-fieldset v-bind:label="$t('AUTHTOKEN')">
            <inputvalidation :formerror="formError" name="authToken"><b-form-input type="text" v-model="formData.authToken" v-bind:placeholder="$t('AUTHTOKEN')"></b-form-input></inputvalidation>
          </b-form-fieldset>
        </div>
      </div>
      <div slot="footer">
        <p class="bg-danger" v-if="formError.error && typeof formError.notice == 'string'">{{formError.notice}}</p>
        <b-button type="submit" size="sm" variant="primary" v-on:click.prevent="saveRow(formData)"><i class="fa fa-dot-circle-o"></i> {{$t('SUBMIT')}}</b-button>
      </div>
    </form>
  </b-card>
</template>

<script>

import { mapGetters } from 'vuex'
import Api from '@/api/admin/UserCompanies'

export default {
  name: 'UsersForm',
  props: ['title', 'formData', 'formError', 'aclGroups', 'status'],
  data()
  {
    return {companydata: {}};
  },
  created()
  {
    this.getCompanyData();
  },
  methods:
  {
    saveRow(formData)
    {
      var me = this;
      me.$emit('saveRow', formData);
    },
    getCompanyData: function()
    {
      var me = this;
      Api.selectRow(me.getParams, function(data)
      {
        if(data.error && data.error == true)
        {
          me.$notify.notice(data);
          return;
        }
        me.companydata = data;
      });
    }
  },
  computed:
  {
    ...mapGetters([
      'globals'
    ])
  }
}
</script>
